var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpRectHollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: silver;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 1.34px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-6 {\r\n        font-size: 8.82px;\r\n        stroke: 0;\r\n        fill: #000;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MemberHelpRectHollow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MemberRectHollow"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.09,146.46V54.55h25.07v91.91Zm25.07,8.35h8.35V46.19H109.73V154.81h33.43Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.51,
    y1: 46.19,
    x2: 109.73,
    y2: 46.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.73,
    y1: 46.19,
    x2: 109.73,
    y2: 154.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 109.73,
    y1: 154.81,
    x2: 151.51,
    y2: 154.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.51,
    y1: 154.81,
    x2: 151.51,
    y2: 46.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.16,
    y1: 146.46,
    x2: 118.09,
    y2: 146.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 118.09,
    y1: 146.46,
    x2: 118.09,
    y2: 54.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 118.09,
    y1: 54.55,
    x2: 143.16,
    y2: 54.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.16,
    y1: 54.55,
    x2: 143.16,
    y2: 146.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.8,
    y1: 42.02,
    x2: 90.8,
    y2: 158.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.8,
    y1: 154.81,
    x2: 88.71,
    y2: 152.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.8,
    y1: 154.81,
    x2: 92.89,
    y2: 156.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.8,
    y1: 154.81,
    x2: 86.62,
    y2: 154.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.8,
    y1: 154.81,
    x2: 105.56,
    y2: 154.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.8,
    y1: 46.19,
    x2: 88.71,
    y2: 44.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 90.8,
    y1: 46.19,
    x2: 92.89,
    y2: 48.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.8,
    y1: 46.19,
    x2: 86.62,
    y2: 46.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 90.8,
    y1: 46.19,
    x2: 105.56,
    y2: 46.19
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(88.1 112.11) rotate(-90)"
  }, "Depth"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 105.56,
    y1: 30.05,
    x2: 155.69,
    y2: 30.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.51,
    y1: 30.05,
    x2: 149.42,
    y2: 32.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.51,
    y1: 30.05,
    x2: 153.6,
    y2: 27.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.51,
    y1: 30.05,
    x2: 151.51,
    y2: 25.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.51,
    y1: 30.05,
    x2: 151.51,
    y2: 42.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.73,
    y1: 30.05,
    x2: 107.65,
    y2: 32.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 109.73,
    y1: 30.05,
    x2: 111.82,
    y2: 27.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.73,
    y1: 30.05,
    x2: 109.73,
    y2: 25.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 109.73,
    y1: 30.05,
    x2: 109.73,
    y2: 42.02
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(119.21 27.36)"
  }, "Width"), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 138.98,
    y1: 98.47,
    x2: 155.69,
    y2: 98.47
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "147.33 98.47 147.86 95.49 149.38 92.81 151.76 90.69 154.76 89.32 158.08 88.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.51,
    y1: 98.47,
    x2: 149.42,
    y2: 100.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 151.51,
    y1: 98.47,
    x2: 153.6,
    y2: 96.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.51,
    y1: 98.47,
    x2: 151.51,
    y2: 94.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 151.51,
    y1: 98.47,
    x2: 151.51,
    y2: 99.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.16,
    y1: 98.47,
    x2: 141.07,
    y2: 100.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 143.16,
    y1: 98.47,
    x2: 145.24,
    y2: 96.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.16,
    y1: 98.47,
    x2: 143.16,
    y2: 94.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.16,
    y1: 98.47,
    x2: 143.16,
    y2: 99.69
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(158.08 92.11)"
  }, "Thickness"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpRectHollow);
export default __webpack_public_path__ + "static/media/MemberHelpRectHollow.ffa4083127a7c282a39c3fcbef012fc1.svg";
export { ForwardRef as ReactComponent };